var styles = {"fontElementMap":"qYzJf","orderedlist":"GNmoH","bulletedlist":"b8zlN","listItem":"-PmAX"};

export { styles as s };
//# sourceMappingURL=lists-16976e92.js.map
